export enum AdminPermissions {
  UnresponsiveCheck = 'jobs-automation/unresponsive-check',
  QueryReportingPlatformAdmin = 'reporting/platform-admin-query',
  CrmView = 'crm/view',
  CrmManageAccounts = 'crm/manage-accounts',
  CrmManageDeals = 'crm/manage-deals',
  AdminImpersonate = 'admin/impersonate',
}
